export default __webpack_public_path__ + "a63d91fb95c52f880271fd3b65852e73.png";